import { AddButton } from 'components/CantileverButton'
import CantileverCard from 'components/CantileverCard'
import React, { useState } from 'react'
import styled from 'styled-components'

import { DetectionModelTable } from './DetectionModelTable'
import { EditDetectionModelModal } from './EditDetectionModelModal'

const TableContainer = styled.div`
  margin: 1rem 0.5rem;
`

export const DetectionModelCard: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [editingModelIndex, setEditingModelIndex] = useState<number | null>(
    null
  )

  const handleAddModel = () => {
    setEditingModelIndex(null)
    setIsModalOpen(true)
  }

  const handleEditModel = (index: number) => {
    setEditingModelIndex(index)
    setIsModalOpen(true)
  }

  const handleCloseModal = () => {
    setIsModalOpen(false)
    setEditingModelIndex(null)
  }

  return (
    <>
      <CantileverCard>
        <CantileverCard.CardHeader
          leadingContent='Detection Models'
          trailingContent={
            <AddButton entityName='Detection Model' onClick={handleAddModel} />
          }
        />
        <CantileverCard.Section>
          <TableContainer>
            <DetectionModelTable onRowClick={handleEditModel} />
          </TableContainer>
        </CantileverCard.Section>
      </CantileverCard>
      <EditDetectionModelModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        editingModelIndex={editingModelIndex}
      />
    </>
  )
}
